<div class="px-6 gap-6 flex flex-col pb-40">

    <form [formGroup]="portalBuilderForm" class="login-container w-full px-6 gap-6 flex flex-col pb-40">
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
            <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">Business Settings</span>
                  </div>
                </mat-card-header>
              </mat-card>
              
            <div class="p-5 w-full grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                <mat-card *ngFor="let item of cards" class="h-60 flex flex-col justify-between">
                    <mat-card-title class="border-l-4 border-primary pl-2">
                        {{ item.heading }}
                    </mat-card-title>
                    <img *ngIf="item.logo" [src]="item.logo" alt="logo" class="h-20 mx-auto" />
                    <div class="text-center">
                        <label [for]="item.type">
                            <button mat-raised-button color="primary">
                                <input [id]="item.type" type="file"  (change)="onFileSelected($event, item.type)" accept="image/*" />
                            </button>
                        </label>
                        
                        
                    </div>
                </mat-card>
            </div>
            <div class="px-5 flex flex-wrap gap-5">
                <mat-form-field class="flex-1 min-w-[250px]">
                  <mat-label>Partner Name</mat-label>
                  <input matInput formControlName="title" placeholder="Enter Your Title text" />
                  <mat-error *ngIf="portalBuilderForm.get('title')?.hasError('required')">
                    Partner Name is required
                  </mat-error>
                </mat-form-field>
              
                <mat-form-field class="flex-1 min-w-[250px]">
                  <mat-label>Select Language</mat-label>
                  <mat-select (selectionChange)="onLanguageSelect($event)" formControlName="defaultLanguage">
                    <mat-option value="" disabled>Select Language</mat-option>
                    <mat-option *ngFor="let language of languageList" [value]="language._id">
                      {{ language?.title }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="portalBuilderForm.get('defaultLanguage')?.hasError('required')">
                    Language is required
                  </mat-error>
                </mat-form-field>
              </div>
              
            
            <div class="p-5">
                <span class="text-lg">Theme Customizer</span>
                <div class="flex flex-col lg:flex-row gap-6">
                    <div *ngIf="roleId == 'admin'" class="flex flex-col gap-2">
                        <span class="flex gap-2 items-center">
                            <img src="../../assets/image/selected-color.svg" /> Primary color Settings
                        </span>
                        <div class="grid grid-cols-5 gap-1">
                            <button *ngFor="let c of colors" mat-mini-fab [ngStyle]="{
                          backgroundColor: c.colorCode,
                          border: selectedColor == c.colorCode ? '2px solid black' : 'none'
                        }" (click)="onPrimeryColorChange(c.colorCode)"></button>
                        </div>
                    </div>

                    <div *ngIf="roleId == 'admin'" class="flex flex-col gap-2">
                        <span class="flex gap-2 items-center">
                            <img src="../../assets/image/selected-color.svg" /> Secondary color Settings
                        </span>
                        <div class="grid grid-cols-5 gap-1">
                            <button *ngFor="let c of colors" mat-mini-fab [ngStyle]="{
                          backgroundColor: c.colorCode,
                          border: selectedSecoundaryColor == c.colorCode ? '2px solid black' : 'none'
                        }" (click)="onSecondaryColorChange(c.colorCode)"></button>
                        </div>
                    </div>

                    <div class="lg:pl-20" *ngIf="roleId == 'admin'">
                        <span class="flex gap-2 items-center">
                            <img src="../../assets/image/selected-color.svg" /> Selected color
                        </span>
                        <div class="flex gap-6">
                            <div class="flex flex-col items-center">
                                <span>Primary</span>
                                <div class="w-10 h-6 border border-black"
                                    [ngStyle]="{ backgroundColor: selectedColor }"></div>
                                <span>{{ selectedColor }}</span>
                            </div>
                            <div class="flex flex-col items-center">
                                <span>Secondary</span>
                                <div class="w-10 h-6 border border-black"
                                    [ngStyle]="{ backgroundColor: selectedSecoundaryColor }"></div>
                                <span>{{ selectedSecoundaryColor }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="px-5" *ngIf="themeLookText">
                <mat-card class="mt-4">{{ themeLookText }}</mat-card>
            </div>
        </div>
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
            <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">System Settings</span>
                  </div>
                </mat-card-header>
              
                <mat-card-content class="p-5">
                  <div class="flex flex-col lg:flex-row gap-6">
                    <!-- Currency -->
                    <mat-form-field  class="w-full">
                      <mat-label>Currency</mat-label>
                      <mat-select
                        formControlName="currency"
                        (selectionChange)="onCurrencySelect($event)"
                      >
                        <mat-option value="" disabled>Select Currency</mat-option>
                        <mat-option
                          *ngFor="let currency of currencyData"
                          [value]="currency._id"
                        >
                          {{ currency?.title }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              
                    <!-- Currency Symbol -->
                    <mat-form-field  class="w-full">
                      <mat-label>Currency Symbol</mat-label>
                      <mat-select formControlName="currencySymbol">
                        <mat-option value="" disabled>Select Currency Symbol</mat-option>
                        <mat-option
                          *ngFor="let currency of currencySymbolData"
                          [value]="currency.symbol"
                        >
                          {{ currency?.symbol }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
              
                </mat-card-content>
              </mat-card>
        </div>
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
              <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">Bank News</span>
                  </div>
                </mat-card-header>
              
                <mat-card-content class="p-5">
                  <div class="flex flex-col lg:flex-row gap-6">
                    <!-- News -->
                    <mat-form-field  class="w-full">
                      <mat-label>News</mat-label>
                      <input matInput formControlName="news" placeholder="Enter News" />
                    </mat-form-field>
              
                    <!-- Bill Notice -->
                    <mat-form-field  class="w-full">
                      <mat-label>Bill Notice</mat-label>
                      <input matInput formControlName="billNotice" placeholder="Enter Notice" />
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>

        </div>
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
            <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">Bank Notice</span>
                  </div>
                </mat-card-header>
              
                <mat-card-content class="p-5 h-[500px]">
                  <angular-editor
                    formControlName="bankNotice"
                    [config]="editorConfig"
                    id="editor1"
                    name="bankNotice"
                  >
                    <ng-template #customButtons let-executeCommandFn="executeCommandFn">
                      <ae-toolbar-set>
                        <ae-button
                          iconClass="fa fa-html5"
                          title="Angular editor logo"
                          (buttonClick)="executeCommandFn('insertHtml')"
                        ></ae-button>
                      </ae-toolbar-set>
                    </ng-template>
                  </angular-editor>
                </mat-card-content>
              </mat-card>
              
        </div>
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
            <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">Bank Settings</span>
                  </div>
                </mat-card-header>
              
                <mat-card-content class="p-5">
                  <form [formGroup]="portalBuilderForm" class="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <ng-container *ngFor="let item of bankSettingForm">
                      <mat-form-field  class="w-full" *ngIf="item.heading !== 'Telephone' && item.heading !== 'Zip/Post Code'">
                        <mat-label>{{ item.heading }} *</mat-label>
                        <input matInput [formControlName]="item.formControlName" [placeholder]="item.placeholder" />
                        <mat-error *ngIf="portalBuilderForm.get(item.formControlName)?.touched && portalBuilderForm.get(item.formControlName)?.invalid">
                          {{ item.errorMsg }}
                        </mat-error>
                      </mat-form-field>
              
                      <!-- Zip/Post Code -->
                      <mat-form-field  class="w-full" *ngIf="item.heading === 'Zip/Post Code'">
                        <mat-label>{{ item.heading }} *</mat-label>
                        <input matInput maxlength="6" (keypress)="keyPressNumbers($event)" [formControlName]="item.formControlName" [placeholder]="item.placeholder" />
                        <mat-error *ngIf="portalBuilderForm.get(item.formControlName)?.touched && portalBuilderForm.get(item.formControlName)?.invalid">
                          {{ item.errorMsg }}
                        </mat-error>
                      </mat-form-field>
              
                      <!-- Telephone -->
                      <mat-form-field  class="w-full" *ngIf="item.heading === 'Telephone'">
                        <mat-label>{{ item.heading }} *</mat-label>
                        <input matInput maxlength="10" (keypress)="keyPressNumbers($event)" [formControlName]="item.formControlName" [placeholder]="item.placeholder" />
                        <mat-error *ngIf="portalBuilderForm.get(item.formControlName)?.touched && portalBuilderForm.get(item.formControlName)?.invalid">
                          {{ item.errorMsg }}
                        </mat-error>
                      </mat-form-field>
                    </ng-container>
              
                    <!-- Country -->
                    <mat-form-field  class="w-full">
                      <mat-label>Country *</mat-label>
                      <mat-select formControlName="country" (selectionChange)="onCountrySelect($event)">
                        <mat-option value="" disabled>India</mat-option>
                      </mat-select>
                    </mat-form-field>
              
                    <!-- State -->
                    <mat-form-field  class="w-full">
                      <mat-label>State *</mat-label>
                      <mat-select formControlName="state" (selectionChange)="onStateSelect($event)">
                        <mat-option value="" disabled>Select State</mat-option>
                        <mat-option *ngFor="let state of stateData" [value]="state._id">{{ state.title }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="portalBuilderForm.get('state')?.touched && portalBuilderForm.get('state')?.invalid">
                        Select valid state
                      </mat-error>
                    </mat-form-field>
              
                    <!-- City -->
                    <mat-form-field  class="w-full">
                      <mat-label>City *</mat-label>
                      <mat-select formControlName="city" (selectionChange)="onCitySelect($event)">
                        <mat-option value="" disabled>Select City</mat-option>
                        <mat-option *ngFor="let city of cityData" [value]="city._id">{{ city.title }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="portalBuilderForm.get('city')?.touched && portalBuilderForm.get('city')?.invalid">
                        Select valid city
                      </mat-error>
                    </mat-form-field>
              
                    <!-- Timezone -->
                    <mat-form-field  class="w-full">
                      <mat-label>Timezone *</mat-label>
                      <mat-select formControlName="bankTimeZone">
                        <mat-option value="" disabled>Select TimeZone</mat-option>
                        <mat-option value="(GMT+5:30) Asia /Kolkata (india standard Time)">
                          (GMT+5:30) Asia /Kolkata (india standard Time)
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="portalBuilderForm.get('bankTimeZone')?.touched && portalBuilderForm.get('bankTimeZone')?.invalid">
                        Select valid timezone
                      </mat-error>
                    </mat-form-field>
              
                    <!-- Support Contact Number -->
                    <mat-form-field  class="w-full">
                      <mat-label>Support Contact Number *</mat-label>
                      <input matInput maxlength="10" (keypress)="keyPressNumbers($event)" formControlName="supportContactNumber" placeholder="Enter Support Contact Number" />
                      <mat-error *ngIf="portalBuilderForm.get('supportContactNumber')?.touched && portalBuilderForm.get('supportContactNumber')?.invalid">
                        Enter valid contact number
                      </mat-error>
                    </mat-form-field>
              
                    <!-- Support Email -->
                    <mat-form-field  class="w-full">
                      <mat-label>Support Email *</mat-label>
                      <input matInput formControlName="supportContactEmail" type="email" placeholder="Enter Support Email" />
                      <mat-error *ngIf="portalBuilderForm.get('supportContactEmail')?.touched && portalBuilderForm.get('supportContactEmail')?.invalid">
                        Enter valid contact email
                      </mat-error>
                    </mat-form-field>
                  </form>
                </mat-card-content>
              </mat-card>
              
        </div>
        <div class="w-full flex flex-col bg-white rounded-xl pb-6">
            <mat-card class="w-full rounded-xl pb-6">
                <mat-card-header class="flex items-center border-b border-gray-300">
                  <div class="flex gap-4 items-center">
                    <div class="h-10 w-1 bg-primary"></div>
                    <span class="text-lg font-semibold">Commission Type</span>
                  </div>
                </mat-card-header>
              
                <mat-card-content class="flex flex-col gap-6">
                  <!-- PayIn Section -->
                  <div>
                    <div class="w-full bg-gray-300 p-2 px-6 text-primary">PayIn *</div>
                    <div class="w-full flex gap-6 p-5 flex-col md:flex-row">
                      <mat-form-field  class="w-full">
                        <mat-label>Commission Type</mat-label>
                        <mat-select formControlName="chargeType">
                          <mat-option value="" disabled>-- Select Commission Type --</mat-option>
                          <mat-option value="flat">Flat</mat-option>
                          <mat-option value="percentage">Percentage</mat-option>
                        </mat-select>
                      </mat-form-field>
              
                      <mat-form-field  class="w-full">
                        <mat-label>Commission On Partner</mat-label>
                        <input matInput
                          type="number"
                          [readonly]="!portalBuilderForm.get('chargeType')?.value"
                          [max]="portalBuilderForm.get('chargeType')?.value == 'percentage' ? 100 : null"
                          [formControlName]="'payInPartner'"
                          placeholder="Enter Commission On Partner" />
                        <mat-error *ngIf="portalBuilderForm.controls['payInPartner'].touched && !portalBuilderForm.controls['payInPartner'].valid">
                          Invalid format or value. Please enter a valid number.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
              
                  <!-- PayOut Section -->
                  <div class="gap-4 flex flex-col">
                    <div class="w-full bg-gray-300 p-2 px-6 text-primary">PayOut *</div>
              
                    <table class="w-full mat-elevation-z1">
                      <tr>
                        <th class="text-left p-2">Range</th>
                        <th class="text-left p-2">Commission Types</th>
                        <th class="text-left p-2">Commission on Partner</th>
                      </tr>
                      <tr *ngFor="let item of payOutTableData">
                        <td class="p-2 border">{{ item.range }}</td>
                        <td class="p-2 border">
                          <mat-form-field  class="w-full">
                            <mat-select [formControlName]="item.rangeChargeType">
                              <mat-option value="" disabled>-- Select Type --</mat-option>
                              <mat-option value="flat">Flat</mat-option>
                              <mat-option value="percentage">Percentage</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td class="p-2 border">
                          <mat-form-field  class="w-full">
                            <input matInput
                              type="number"
                              [readonly]="!portalBuilderForm.get(item.rangeChargeType)?.value"
                              [max]="portalBuilderForm.get(item.rangeChargeType)?.value == 'percentage' ? 100 : null"
                              [formControlName]="item.rangeChargePartner"
                              placeholder="Enter Commission" />
                          </mat-form-field>
                        </td>
                      </tr>
                    </table>
              
                    <div *ngIf="
                          (portalBuilderForm.controls['chargePartnerOne'].touched && !portalBuilderForm.controls['chargePartnerOne'].valid) ||
                          (portalBuilderForm.controls['chargePartnerTwo'].touched && !portalBuilderForm.controls['chargePartnerTwo'].valid) ||
                          (portalBuilderForm.controls['chargePartnerThree'].touched && !portalBuilderForm.controls['chargePartnerThree'].valid)"
                      class="text-red-500 px-2">
                      Invalid format or value. Please enter a valid number with up to two decimal places.
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              
        </div>

        <div class="w-full bg-white p-2 rounded-xl flex gap-4 px-5 justify-end items-center">
            <button mat-raised-button color="primary" (click)="createPortalBuilder()">Save</button>
          </div>
    </form>
</div>